import { useTranslation } from "react-i18next";
import CTA from "@/components/atoms/CTA";
import { useAuth } from "@/contexts/AuthContext";
import { useInspectionModalStore } from "@/stores/inspectionModalStore";

interface InspectOrderCTAProps {
  orderId: number;
}

/** Order Inspections: opens the inspection modal for an order. Used inside clickable table rows. */
export default function InspectOrderCTA({ orderId }: InspectOrderCTAProps) {
  const { t } = useTranslation();
  const { currentCompany, isViewer } = useAuth();
  const openInspection = useInspectionModalStore((s) => s.open);

  return (
    <CTA
      data-testid={`inspect-order-${orderId}`}
      disabled={isViewer(currentCompany)}
      onClick={(event) => {
        // The row itself opens the order drawer.
        event.stopPropagation();
        openInspection(orderId);
      }}
    >
      {t("inspections:registerReceipt")}
    </CTA>
  );
}
